import React from 'react';
// import { Input } from 'antd';
// import { SearchOutlined } from '@ant-design/icons';
import { SortButton } from './SortButton';

export const AssetSearch = (): JSX.Element => (
  <div
    style={{
      padding: '32px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      backgroundColor: '#fff',
    }}
  >
    <span style={{ fontSize: '20px', fontWeight: 600 }}>Assets</span>
    <div style={{ display: 'flex', gap: '8px' }}>
      {/* <Input
        disabled
        placeholder="Search"
        prefix={<SearchOutlined style={{ color: '#E1E3E8' }} />}
        style={{
          width: '100%',
          borderColor: '#E1E3E8',
          color: '#D0D3D9',
          height: '32px',
          borderRadius: '8px',
        }}
      /> */}
      <SortButton />
      <>
      </>
    </div>
  </div>
);
